import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import Table from '@/common/components/Table'
import { useConsumptionsByStatus } from '@/common/hooks/queries/useConsumptionsByStatus'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { FailedConsumptionData } from '@/common/types/client/failedConsumption.type'
import useEstablishmentCompany from '@/features/establishments/hooks/useEstablishmentCompany'
import { EstablishmentFailedConsumptionsTransformer } from '@/features/establishments/services/establishmentFailedConsumptionsTransformer'
import { EstablishmentFailedConsumptionTableItem } from '@/features/establishments/types/establishmentFailedConsumption.type'
import { useParams } from 'react-router-dom'
import { defaultColumns } from './columns'
import Filters from './components/Filters'

const FailedConsumptionsList = () => {
  const { id: id } = useParams()

  const { filterParams, setFilterParams } = useFilterParams()

  const { data: establishmentCompany } = useEstablishmentCompany(id)

  const {
    data: failedConsumptions,
    meta,
    isFetching: failedConsumptionsIsFetching,
    error: failedConsumptionsError = {} as any,
    refetch: refetchFailedConsumptions,
  } = useConsumptionsByStatus({
    filters: {
      status: 'failed',
      page: filterParams.page || 1,
      establishmentCompanyId: establishmentCompany?.id,
      clientCompanyId: filterParams.client?.value,
      clientBranchId: filterParams.branch?.value,
    },
    mapper: Mapper.mapWithTransformer<FailedConsumptionData[], EstablishmentFailedConsumptionTableItem[]>({
      transformer: EstablishmentFailedConsumptionsTransformer.tableTransformer(),
    }),
  })

  return (
    <ErrorMessageWrapper
      className="h-[calc(100vh-192px)]"
      statusCode={failedConsumptionsError?.status}
      refetchFunction={refetchFailedConsumptions}
    >
      <div className="flex flex-col gap-6">
        <Filters />

        <Table
          className="max-h-[calc(100vh-248px)]"
          columns={defaultColumns}
          isLoadingData={failedConsumptionsIsFetching}
          page={filterParams.page || 1}
          rows={failedConsumptions}
          totalPages={meta.total_pages}
          totalCount={meta.total}
          hasPagination
          rowEmptyValue="--"
          setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        />
      </div>
    </ErrorMessageWrapper>
  )
}

export default FailedConsumptionsList
